import React from 'react';
import { Typography, Tag, Button } from 'antd';
import { CloseCircleFilled } from '@ant-design/icons';
import { CreativityContentData } from '../../types/banner';
import { getBannerStatusData } from '../../utils';
import { useTemplateInfo } from '../../hooks/banners/use-template-utils';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import { StatusTag } from '../ui/status-tag';

const { Title } = Typography;

interface AssetModalHeaderProps {
  creativity: CreativityContentData;
  onClose: () => void;
}

export const AssetModalHeader: React.FC<AssetModalHeaderProps> = ({ creativity, onClose }) => {
  const { fontSize, spacing, screens } = useResponsiveSizes();
  const { title } = useTemplateInfo(!creativity.bannerType ? undefined : creativity.bannerType);
  // getBannerStatusData puede devolver undefined (p.ej. reels en PROCESSING/READY, que no están
  // en el statusMap de BannerStatus). Calculamos una vez y guardamos el render con `statusData?.label`.
  const statusData = getBannerStatusData(creativity);

  return (
    <div style={{ position: 'relative' }}>
      {/* Botón de cerrar */}
      <Button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: spacing.sm,
          right: spacing.sm,
          background: 'transparent',
          border: 'none',
          borderRadius: '50%',
          width: screens.xs ? '32px' : '36px',
          height: screens.xs ? '32px' : '36px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 20,
          color: '#64748b',
          transition: 'all 0.2s',
          zIndex: 10
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.02)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        <CloseCircleFilled />
      </Button>

      {/* Header content */}
      <div
        style={{
          background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
          padding: `${spacing.md}px ${spacing.lg}px`,
          borderBottom: '1px solid #e2e8f0'
        }}
      >
        <div style={{ display: 'flex', gap: spacing.md }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Title
              style={{
                margin: '0 0 4px 0',
                color: '#0f172a',
                fontWeight: 'bold',
                lineHeight: 1.3,
                marginBottom: spacing.sm,
                fontSize: fontSize.xxl
              }}
            >
              {creativity?.title || 'Nuevo contenido creativo'}
            </Title>

            <div style={{ display: 'flex', gap: spacing.sm, flexWrap: 'wrap' }}>
              {!creativity.bannerType && title && (
                <Tag
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: 12,
                    fontSize: fontSize.xxl,
                    padding: `${spacing.sm}px ${spacing.sm}px`,
                    fontWeight: 800,
                    height: 20,
                    lineHeight: '20px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    textTransform: 'uppercase'
                  }}
                >
                  {title}
                </Tag>
              )}

              {statusData?.label && <StatusTag label={statusData.label} size='medium' />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
